"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePortal = void 0;

var _react = require("react");

var _utils = require("../utils");

const createRootElement = id => {
  var _windowGlobal, _windowGlobal$documen;

  const rootContainer = (_windowGlobal = (0, _utils.windowGlobal)()) == null ? void 0 : (_windowGlobal$documen = _windowGlobal.document) == null ? void 0 : _windowGlobal$documen.createElement('div');
  rootContainer == null ? void 0 : rootContainer.setAttribute('id', id);
  return rootContainer;
};

const addRootElement = rootElement => {
  var _windowGlobal2, _windowGlobal2$docume, _windowGlobal2$docume2;

  (_windowGlobal2 = (0, _utils.windowGlobal)()) == null ? void 0 : (_windowGlobal2$docume = _windowGlobal2.document) == null ? void 0 : (_windowGlobal2$docume2 = _windowGlobal2$docume.body) == null ? void 0 : _windowGlobal2$docume2.appendChild(rootElement);
};

const usePortal = id => {
  const rootElementRef = (0, _react.useRef)(null);

  const setupElement = () => {
    var _windowGlobal3, _windowGlobal3$docume;

    const existingParent = (_windowGlobal3 = (0, _utils.windowGlobal)()) == null ? void 0 : (_windowGlobal3$docume = _windowGlobal3.document) == null ? void 0 : _windowGlobal3$docume.querySelector(`#${id}`);
    const parentElement = existingParent || createRootElement(id);

    if (!existingParent) {
      addRootElement(parentElement);
    }

    parentElement == null ? void 0 : parentElement.appendChild(rootElementRef.current);
    return () => {
      var _rootElementRef$curre;

      (_rootElementRef$curre = rootElementRef.current) == null ? void 0 : _rootElementRef$curre.remove();

      if (!parentElement.childElementCount) {
        parentElement == null ? void 0 : parentElement.remove();
      }
    };
  };

  const getRootElement = () => {
    if (!rootElementRef.current) {
      var _windowGlobal4, _windowGlobal4$docume;

      rootElementRef.current = (_windowGlobal4 = (0, _utils.windowGlobal)()) == null ? void 0 : (_windowGlobal4$docume = _windowGlobal4.document) == null ? void 0 : _windowGlobal4$docume.createElement('div');
    }

    return rootElementRef.current;
  };

  (0, _react.useEffect)(setupElement, [id]);
  return getRootElement();
};

exports.usePortal = usePortal;